import script from "./RelatedPersonName.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelatedPersonName.vue3.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__